module.exports = __webpack_public_path__ + "media/images/vipio-ontdek-unieke-overnachtingen-en-vakanties-3-5e6cc80f9884b384bc5d9747ba063480.jpg";